import React from 'react'

export enum PromoBannersType {
  STAKE = 'STAKE',
  REWARD = 'REWARD',
  VESTING = 'VESTING',
  BRIDGE = 'BRIDGE'
}

interface PromoBannersProps {
  type: PromoBannersType
}

/**
 * Promo banners sourced from external CMS have been retired with the standalone MPRO Lab migration.
 * Component intentionally renders nothing; keep props for backwards compatibility with callers.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const PromoBanners: React.FC<PromoBannersProps> = (_props) => {
  return null
}

export default PromoBanners
